export enum ECacheTime {
  FIVE_MINUTES = 300,
  FIFTEEN_MINUTES = 900,
  ONE_HOUR = 3600,
  THREE_HOURS = 10800,
  TWELVE_HOURS = 43200,
  ONE_DAY = 86400,
  ONE_WEEK = 604800,
  ONE_MONTH = 2592000,
  ONE_YEAR = 31536000,
}

export enum ECacheTag {
  CAMPAIGNS = 'campaigns',
  HOME = 'home',
  SETTINGS = 'settings',
  PRODUCTS = 'products',
}
